import tariffRecommenderImage from '../../../assets/images/tariffs-illustration-utilita.png';
import welcomeModalIllustration from '../../../assets/svg/welcome-modal-illustration-utilita.svg';
import type { Images } from '../ThemeTypes';

const images: Images = {
  tariffRecommender: {
    mainCardLogo: tariffRecommenderImage,
    width: '100%',
    '${min.sm}': {
      width: '200px',
    },
  },
  welcomeModal: {
    headerBackground: '#00AEEF',
    illustration: welcomeModalIllustration,
  },
};

export default images;
